// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_2K90bUudHL","userImpersonationContainer":"_1noZru2QQd"};